<script>
  // import { LazyImage } from 'svelte-lazy-image';
  export let src;

  // const options = { rootMargin: "1200px 0px 1200px 0px" };
  // const placeholder = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";

	$: cssClass = $$props.class || '';
</script>

<div class="lazy-img {cssClass}">
  <!--
    <LazyImage {src} alt="" {options} {placeholder} />
  -->
  <img {src} alt="">
</div>


<style>
  .lazy-img {
    position: relative;
    height: 0;
    width: 100%;
    padding-bottom: 66%;
    background: rgba(110, 110, 110, 0.5);
    overflow: hidden;
  }

  .lazy-img :global(img) {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    min-height: 100%;
    /*
    opacity: 0;
    transition: opacity 0.2s;
    */
  }

  .lazy-img :global(.svelte-lazy-image--loaded) {
    opacity: 1;
  }
</style>
